import elementReady from '../utils/elementReady'

async function resolveElement(elementOrSelector) {
  if (isRef(elementOrSelector))
    return toValue(elementOrSelector)

  if (typeof elementOrSelector === 'object')
    return elementOrSelector

  else if (typeof elementOrSelector === 'string')
    return elementReady(elementOrSelector)

  return Promise.reject(new Error('elementOrSelector must be a ref, object, or string'))
}

export function useElementHeight(elementOrSelector, { onResize, fallbackElement = document.body } = {}) {
  const height = ref(0)

  const initialize = async () => {
    const wrapperElement = await resolveElement(elementOrSelector).catch(() => fallbackElement)

    const updateHeight = () => {
      const value = wrapperElement.scrollHeight
      if (height.value !== value) {
        height.value = value
        if (onResize)
          onResize(value)
      }
    }

    updateHeight()
    useResizeObserver(wrapperElement, () => {
      updateHeight()
    })
    useMutationObserver(wrapperElement, () => {
      updateHeight()
    }, { childList: true, subtree: true })
  }

  initialize()

  return { height }
}
